(async () => {
  const ownScript = document.currentScript;
  const roots = document.querySelectorAll('[data-flatout-layer-root]:not([data-layer-ready])');
  for (const root of roots) {
    root.dataset.layerReady = 'true';
    const section = root.closest('.shopify-section');
    const canvas = root.querySelector('canvas');
    const fallback = root.querySelector('[data-layer-fallback]');
    const track = root.querySelector('[data-layer-track]');
    let slides = [...track.querySelectorAll('[data-layer-slide]')];
    const previous = root.querySelector('[data-layer-prev]');
    const next = root.querySelector('[data-layer-next]');
    const features = root.querySelector('[data-layer-features]');
    const mobileLayout = matchMedia('(max-width:767px)');
    const stage = root.querySelector('.flatout-config-stage');
    const main = root.querySelector('.main-image');
    const thumbs = [...features.querySelectorAll('[data-layer-thumb]')];
    let slideIndex = 0;
    function placeFeatures() {
      const purchaseRow = section.querySelector('.js-product-form')?.closest('.input-row');
      if (mobileLayout.matches) {
        main.prepend(stage);
        if (purchaseRow) purchaseRow.after(features);
        else root.closest('product-form').after(features);
      } else {
        main.prepend(features);
        track.prepend(stage);
      }
      slides = [...track.children];
      slideIndex = 0;
      goToSlide(0, false);
      galleryState();
    }
    mobileLayout.addEventListener('change', placeFeatures);
    root.querySelector('.flatout-feature-link').addEventListener('click', event => {
      event.preventDefault(); event.stopImmediatePropagation();
      features.scrollIntoView({ behavior:'instant', block:'start' });
    }, true);
    const surprise = root.querySelector('[data-layer-surprise]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    function galleryState() {
      slideIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
      features.querySelector('[data-layer-counter]').textContent = `${slideIndex + 1} / ${slides.length}`;
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(!mobileLayout.matches && index === slideIndex)));
      previous.disabled = slideIndex === 0;
      next.disabled = slideIndex === slides.length - 1;
    }
    function goToSlide(index, smooth = true) {
      track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, index)) * track.clientWidth, behavior: smooth && !reducedMotion ? 'smooth' : 'instant' });
    }
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goToSlide(index)));
    placeFeatures();
    previous.addEventListener('click', () => goToSlide(slideIndex - 1));
    next.addEventListener('click', () => goToSlide(slideIndex + 1));
    track.addEventListener('scroll', galleryState, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault(); goToSlide(slideIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    const resizeObserver = new ResizeObserver(() => { goToSlide(slideIndex, false); galleryState(); });
    resizeObserver.observe(track);
    galleryState();
    const status = root.querySelector('[data-layer-status]');
    const retry = root.querySelector('[data-layer-retry]');
    const config = JSON.parse(root.querySelector('[data-layer-config]').textContent);
    const { ImageQueue, LatestRenderer, LatestRequest, selectionAssets, validateManifest } = await import(ownScript.dataset.core);
    const requests = new LatestRequest();
    let manifest;
    let pending = false;
    let failed = false;
    let imageGeneration = 0;
    let preloadStarted = false;
    let activeSelection;
    let confirmedVariant;
    let renderStarted = 0;
    let width;
    let height;
    const strings = config.strings;
    const queue = new ImageQueue(url => new Promise((resolve, reject) => {
      const image = new Image();
      image.decoding = 'async';
      image.onload = async () => {
        try {
          await image.decode();
          if (Math.abs(image.naturalWidth / image.naturalHeight - manifest.width / manifest.height) > 0.002) throw new Error('Layer aspect ratio mismatch');
          resolve(image);
        } catch (error) { reject(error); }
      };
      image.onerror = () => reject(new Error('Image unavailable'));
      const src = new URL(url, location.origin);
      if (src.hostname === 'cdn.shopify.com' || src.pathname.includes('/cdn/shop/')) src.searchParams.set('width', width);
      image.src = src.toString();
    }));
    const renderer = new LatestRenderer(queue, images => {
      const context = canvas.getContext('2d');
      context.clearRect(0, 0, canvas.width, canvas.height);
      for (const image of images) context.drawImage(image, 0, 0, canvas.width, canvas.height);
      root.dataset.renderMs = String(Math.round((performance.now() - renderStarted) * 10) / 10);
      const thumbnail = root.querySelector('[data-layer-thumb-canvas]') || features.querySelector('[data-layer-thumb-canvas]');
      const thumbnailContext = thumbnail.getContext('2d');
      thumbnailContext.clearRect(0, 0, 96, 120);
      thumbnailContext.drawImage(canvas, 0, 0, 96, 120);
      canvas.hidden = false;
      fallback.hidden = true;
      canvas.setAttribute('aria-label', `${config.title} — ${activeSelection.join(' / ')}`);
    });
    function message(text) { status.textContent = text; }
    function gate(value) {
      pending = value;
      section.toggleAttribute('data-flatout-pending', pending || failed);
      const button = section.querySelector('.js-product-form [name="add"]');
      if (button && (pending || failed)) button.disabled = true;
      if (button) button.setAttribute('aria-busy', String(pending));
    }
    function confirmed() {
      const picker = section.querySelector('variant-picker');
      return !pending && !failed && confirmedVariant?.available && JSON.stringify(confirmedVariant.options) === JSON.stringify(selection(picker));
    }
    function syncCartId() {
      if (!confirmedVariant) return;
      section.querySelectorAll('.js-product-form input[name="id"], .js-instalments-form input[name="id"]').forEach(input => { input.value = String(confirmedVariant.id); });
    }
    section.addEventListener('submit', event => {
      if (!event.target.matches('.js-product-form')) return;
      if (!confirmed()) {
        event.preventDefault(); event.stopImmediatePropagation();
        message(strings.variantError);
        return;
      }
      syncCartId();
    }, true);
    section.querySelector('.js-product-form')?.addEventListener('formdata', event => {
      if (confirmed()) event.formData.set('id', String(confirmedVariant.id));
    });
    section.addEventListener('click', event => {
      if ((pending || failed) && event.target.closest('.shopify-payment-button, [name="add"]')) {
        event.preventDefault(); event.stopImmediatePropagation();
      }
    }, true);
    function selection(picker) { return picker.getSelectedOptions(); }
    function background() {
      if (preloadStarted || !manifest) return;
      preloadStarted = true;
      const urls = ['frames', 'lenses', 'straps'].flatMap(group => Object.values(manifest[group]).map(asset => asset.url)).filter(Boolean);
      const start = () => queue.preload(urls).then(() => { root.dataset.preloaded = String(new Set(urls.filter(url => queue.peek(url))).size); });
      if (navigator.connection?.saveData) return;
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1200 });
      else setTimeout(start, 200);
    }
    async function show(selectionValue) {
      if (!mobileLayout.matches) goToSlide(0, false);
      renderStarted = performance.now();
      activeSelection = selectionValue;
      const generation = ++imageGeneration;
      const urls = manifest && selectionAssets(manifest, selectionValue);
      if (!urls) {
        renderer.cancel();
        canvas.hidden = true;
        fallback.hidden = false;
        message(strings.waiting);
        return;
      }
      message(queue.peek(urls[0]) && urls.every(url => queue.peek(url)) ? '' : strings.loading);
      try {
        if (await renderer.show(urls) && generation === imageGeneration) {
          message(''); background();
        }
      } catch {
        if (generation !== imageGeneration) return;
        message(strings.imageError);
        retry.hidden = false;
      }
    }
    function readVariant(doc) {
      return JSON.parse(doc.querySelector('variant-picker script[type="application/json"]')?.textContent || 'null');
    }
    function applyResponse(doc, picker, expected) {
      const nextPicker = doc.querySelector('variant-picker');
      if (!nextPicker) throw new Error('Missing variant response');
      const variant = readVariant(doc);
      if (!variant || JSON.stringify(variant.options) !== JSON.stringify(expected)) throw new Error('Variant selection mismatch');
      for (const target of section.querySelectorAll('[data-dynamic-variant-content]')) {
        if (!target.isConnected || target.contains(picker) || picker.contains(target)) continue;
        const key = target.dataset.dynamicVariantContent;
        const source = doc.querySelector(`[data-dynamic-variant-content="${CSS.escape(key)}"]`);
        if (source) target.replaceWith(source);
      }
      for (const input of picker.querySelectorAll('.js-option[data-value-id]')) {
        const source = nextPicker.querySelector(`.js-option[data-value-id="${CSS.escape(input.dataset.valueId)}"]`);
        if (!source) continue;
        input.className = source.className;
        for (const key of ['variantId', 'productUrl']) {
          if (source.dataset[key]) input.dataset[key] = source.dataset[key];
          else delete input.dataset[key];
        }
      }
      const json = picker.querySelector('script[type="application/json"]');
      json.textContent = JSON.stringify(variant);
      picker.variant = variant;
      confirmedVariant = variant;
      picker.selectedOptionIds = picker.getSelectedOptionIds();
      picker.updateVariantContent();
      section.querySelectorAll('.js-product-form input[name="id"], .js-instalments-form input[name="id"]').forEach(input => {
        input.value = variant.id;
      });
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      url.searchParams.delete('option_values');
      for (const option of picker.optionSelectors) url.searchParams.delete(option.dataset.option);
      history.replaceState(history.state, '', url);
      picker.dispatchEvent(new CustomEvent('on:variant:change', { bubbles: true, detail: { form: picker.getProductForm(), variant, selectedOptions: expected } }));
      syncCartId();

    }
    function variantUrl(ids) {
      const url = new URL(picker.dataset.url, location.origin);
      for (const key of ['view', 'preview_theme_id', 'pb']) {
        const value = new URL(location.href).searchParams.get(key);
        if (value) url.searchParams.set(key, value);
      }
      url.searchParams.set('section_id', picker.dataset.sectionId);
      url.searchParams.set('option_values', ids.join(','));
      return url;
    }
    let surpriseGeneration = 0;
    async function surpriseMe() {
      const generation = ++surpriseGeneration;
      const request = requests.next();
      surprise.disabled = true;
      surprise.setAttribute('aria-busy', 'true');
      failed = false;
      gate(true);
      const timeout = setTimeout(() => { if (request.current()) requests.controller.abort(); }, 15000);
      try {
        const groups = [...picker.querySelectorAll('.option-selector')].map(group => [...group.querySelectorAll('input.js-option[data-value-id]')]);
        for (let attempt = 0; attempt < 15; attempt++) {
          const chosen = groups.map(group => group[Math.floor(Math.random() * group.length)]);
          const expected = chosen.map(input => input.value);
          if (!selectionAssets(manifest, expected) || JSON.stringify(expected) === JSON.stringify(selection(picker))) continue;
          const response = await fetch(variantUrl(chosen.map(input => input.dataset.valueId)).toString(), { signal: request.signal, credentials:'same-origin' });
          if (!response.ok) throw new Error('Variant request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!request.current()) return;
          const variant = readVariant(doc);
          if (!variant?.available || JSON.stringify(variant.options) !== JSON.stringify(expected)) continue;
          chosen.forEach(input => { input.checked = true; });
          picker.updateSwatchLabel();
          applyResponse(doc, picker, expected);
          show(expected);
          gate(false);
          picker.updateAddToCartButton();
          chosen.forEach(input => {
            const label = picker.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            const row = input.closest('.option-selector')?.querySelector('.option-selector__btns');
            if (label && row) row.scrollTo({ left: label.offsetLeft - row.offsetLeft - row.clientWidth / 2 + label.offsetWidth / 2, behavior:'instant' });
          });
          return;
        }
        throw new Error('No available suggestion found');
      } catch {
        if (request.current()) {
          gate(false);
          picker.updateAddToCartButton();
          message(document.documentElement.lang.startsWith('fi') ? 'Uutta yhdistelmää ei löytynyt. Kokeile uudelleen.' : 'Could not find a new available combination. Please try again.');
        }
      } finally {
        clearTimeout(timeout);
        if (generation === surpriseGeneration) {
          surprise.disabled = false;
          surprise.setAttribute('aria-busy','false');
        }
      }
    }
    async function update(picker) {
      const expected = selection(picker);

      picker.selectedOptionIds = picker.getSelectedOptionIds();
      picker.updateSwatchLabel();
      show(expected);
      const request = requests.next();
      failed = false;
      retry.hidden = true;
      gate(true);
      const url = variantUrl(picker.selectedOptionIds);
      const timeout = setTimeout(() => { if (request.current()) requests.controller.abort(); }, 12000);
      try {
        const response = await fetch(url.toString(), { signal: request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Variant request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!request.current()) return;
        applyResponse(doc, picker, expected);
        failed = false;
        gate(false);
        picker.updateAddToCartButton();

      } catch (error) {
        if (!request.current()) return;
        failed = true;
        gate(false);
        message(strings.variantError);
        retry.hidden = false;
      } finally { clearTimeout(timeout); }
    }
    await customElements.whenDefined('variant-picker');
    const picker = section.querySelector('variant-picker');
    if (!picker) continue;
    confirmedVariant = picker.variant;
    section.addEventListener('change', event => {
      if (!event.target.closest('variant-picker')) return;
      event.stopImmediatePropagation();
      update(section.querySelector('variant-picker'));
    }, true);
    picker.querySelectorAll('.opt-label').forEach(label => {
      label.removeEventListener('mouseenter', picker.boundHandleLabelMouseEnter);
      label.removeEventListener('touchstart', picker.boundHandleLabelMouseEnter);
    });
    surprise.addEventListener('click', surpriseMe);
    retry.addEventListener('click', () => update(section.querySelector('variant-picker')));
    try {
      manifest = validateManifest(JSON.parse(root.querySelector('[data-layer-manifest]').textContent));
      width = Math.min(1200, Math.ceil(Math.max(root.clientWidth, 320) * Math.min(devicePixelRatio || 1, 2) / 100) * 100);
      height = Math.round(width * manifest.height / manifest.width);
      canvas.width = width; canvas.height = height;
      show(selection(picker));
      surprise.disabled = false;
    } catch { message(strings.waiting); retry.hidden = false; }
    document.addEventListener('shopify:section:unload', event => {
      if (event.target !== section) return;
      requests.cancel(); renderer.cancel(); resizeObserver.disconnect(); mobileLayout.removeEventListener('change', placeFeatures);
    }, { once: true });
  }
})();


// Mobile purchase shortcut delegates to the original, availability-guarded form.
(() => {
  const section = document.querySelector('[data-flatout-layer-root]')?.closest('.shopify-section');
  if (!section || document.querySelector('.flatout-sticky-cart')) return;
  const bar = document.createElement('div');
  bar.className = 'flatout-sticky-cart';
  bar.innerHTML = '<span class="flatout-sticky-price"></span><button type="button" class="btn flatout-sticky-submit" disabled></button>';
  document.body.append(bar);
  const button = bar.querySelector('button');
  const price = bar.querySelector('.flatout-sticky-price');
  let original, inView = false, scheduled = false;
  const observer = new IntersectionObserver(entries => {
    inView = entries.some(entry => entry.isIntersecting);
    bar.classList.toggle('is-original-visible', inView);
  });
  const sync = () => {
    scheduled = false;
    const next = section.querySelector('.js-product-form [name="add"]');
    if (next !== original) { observer.disconnect(); original = next; if (next) observer.observe(next); }
    const text = next?.textContent.trim() || 'Add to cart';
    if (button.textContent !== text) button.textContent = text;
    button.disabled = !next || next.disabled || section.hasAttribute('data-flatout-pending');
    button.setAttribute('aria-busy', next?.getAttribute('aria-busy') || 'false');
    const currentPrice = section.querySelector('.price-container .price__current .js-value') || section.querySelector('.price-container .price');
    const amount = currentPrice?.textContent.trim() || '';
    if (price.textContent !== amount) price.textContent = amount;
  };
  const changes = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } });
  changes.observe(section, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-busy','data-flatout-pending']});
  button.addEventListener('click', () => { sync(); if (!button.disabled) original.click(); });
  document.body.classList.add('has-flatout-sticky-cart');
  sync();
  document.addEventListener('shopify:section:unload', event => {
    if (event.target !== section) return;
    changes.disconnect(); observer.disconnect(); bar.remove(); document.body.classList.remove('has-flatout-sticky-cart');
  });
})();
